import { flatten, isNil } from 'lodash';

import {
  AdvancementReadyToAward,
  GetOrgAdvancementsReadyToAwardResponse,
} from '@appTypes/esb';
import advancementStatusDate from '@shared/utils/advancementStatusDate';
import personNameBuilder from '@utils/personNameBuilder';

const denormalizeAdvancement = (
  advancement: AdvancementReadyToAward,
  advancementType: string,
) => {
  if (isNil(advancement)) return [];

  const { id, members } = advancement;
  return members.map((youth, i) => ({
    key: `${advancementType}.${id}.${youth.userId}.${i}`,
    ...advancement,
    advancementId: id,
    advancementType: `${advancementType}s`,
    members: undefined,
    youth: {
      ...youth,
      dateCompletedEarned:
        advancementStatusDate.getCompleted(youth) ||
        advancementStatusDate.getApproved(youth),
      shortName: personNameBuilder.short(youth),
    },
  }));
};

const getItems = (
  advancement: Array<AdvancementReadyToAward[] | AdvancementReadyToAward>,
  advancementType: string,
) => {
  const data = flatten(advancement);
  const normalized = data.flatMap(advancement =>
    denormalizeAdvancement(advancement, advancementType),
  );

  return normalized;
};

export function mapAdvancementReportDtoToModel(
  report: GetOrgAdvancementsReadyToAwardResponse,
) {
  return (
    report.reduce(
      (acc, { advancementType, advancements }) => [
        ...acc,
        ...getItems(advancements, advancementType),
      ],
      [],
    ) || []
  );
}
